import simulatorConfig from '../constants/simulator-config-constants';
import { ExperimentConfiguration } from '../models';

type SimulatorConfig = (typeof simulatorConfig)[keyof typeof simulatorConfig];

export const getSelectedValueFromSimulatorConfig = (
  config: ExperimentConfiguration[],
  configParameter: SimulatorConfig
): string | undefined => config?.find((c) => c.name === configParameter)?.selectedValue;
